var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bookmark-toggle"},[_c('a',{attrs:{"role":"button","title":"Bookmarked items"},on:{"click":_vm.onClick}},[(_vm.counter > 0)?_c('span',{staticClass:"counter"},[_vm._v(_vm._s(_vm.counter))]):_vm._e(),_c('font-awesome-icon',{attrs:{"icon":"bookmark"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }